import enumeration from "./enumeration";

const DiscountStatus = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
  Expired: "EXPIRED",
};

export default enumeration(DiscountStatus);
